import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Keyboard, Lazy, Mousewheel } from "swiper"

Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Keyboard, Lazy, Mousewheel])

"use strict";

document.addEventListener("DOMContentLoaded", () => {

	if (document.querySelector('.stories')) {
        window.stories = new storiesSlider();
    }

});


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// stories
var storiesSlider = function () {
	function storiesSlider() {
		_classCallCheck(this, storiesSlider);

		// this.goodsButton = document.querySelector('.stories__goods-title span');
		// this.storiesGoods = document.querySelector('.story-goods');
		this.storiesButtons = document.querySelectorAll('.stories-list__item .story');
		this.storiesPopup = document.querySelector('.stories__popup');
		this.closeButton = document.querySelector('.stories__popup-close');
		this.firstLevelSwiper = null;
		this.secondLevelSwipers = [];
		this.activeStory = 1;

		this.create();
		this.init();
	}

	_createClass(storiesSlider, [{
		key: "init",
		value: function init() {
			this.firstLevelSwiper.init();
		}
	}, {
		key: "create",
		value: function create() {
			var _this3 = this;

			//Открыть слайдер
			var html = document.querySelector('html');
			var head = document.querySelector('.header');
			this.storiesButtons.forEach(function (button) {
				button.addEventListener('click', function (evt) {
					var id = button.getAttribute('data-id');
					_this3.storiesPopup.classList.add('js__visible');
					html.classList.add('stories-opened');
					head.classList.add('stories-opened');
					_this3.activeStory = id;
					_this3.slideByIndex(id);
					_this3.setAutoplay(id);
				});
			});
			//Кнопка закрыть слайдер
			this.closeButton.addEventListener('click', function () {
				_this3.storiesPopup.classList.remove('js__visible');
				html.classList.remove('stories-opened');
				head.classList.remove('stories-opened');
				_this3.pauseAll();
			});

			// Инициализация swiper первого уровня
			this.firstLevelSwiper = new Swiper('.first-level-stories-slider', {
				slidesPerView: 1,
				spaceBetween: 10,
				centeredSlides: true,
				simulateTouch: true,
				// shortSwipes: false,
				longSwipesRatio: 0.2,
				slideToClickedSlide: true,
				keyboard: {
					enabled: true
				},
				init: false,
				on: {
					init: function init() {
						_this3.createFirstLevelListeners();
						// _this3.createGoodsListeners();
					},

					slideChange: function slideChange() {
						_this3.activeStory = _this3.firstLevelSwiper.activeIndex;
						_this3.setAutoplay(_this3.firstLevelSwiper.activeIndex);
					},
					touchStart: function touchStart(ev) {
						_this3.secondLevelSwipers[_this3.activeStory].autoplay.pause();
						_this3.secondLevelSwipers[_this3.activeStory].el.querySelector('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress').classList.add('paused');
					},
					touchEnd: function touchEnd(ev) {
						_this3.secondLevelSwipers[_this3.activeStory].autoplay.start();
						_this3.secondLevelSwipers[_this3.activeStory].el.querySelector('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress').classList.remove('paused');
					}
				},
				breakpoints: {
					1600: {
						spaceBetween: 150,
						slidesPerView: 3
					},
					1280: {
						spaceBetween: 80,
						slidesPerView: 3
					},
					1040: {
						spaceBetween: 40,
						slidesPerView: 2
					},
					1000: {
						spaceBetween: 10,
						slidesPerView: 1,
						shortSwipes: true
					}
				}
			});

			// Иницилизация всех  swiper второго уровня
			document.querySelectorAll('.second-level-stories-slider').forEach(function (slider) {
				var sliderContext = _this3;
				var swiper = new Swiper(slider, {
					autoplay: {
						delay: 4000,
						stopOnLastSlide: true,
						disableOnInteraction: false
					},
					effect: "fade",
					followFinger: false,
					allowTouchMove: false,
					simulateTouch: false,
					// lazy: {
					// 	loadPrevNext: true
					// },
					navigation: {
						prevEl: slider.querySelector(".swiper-button-prev"),
						nextEl: slider.querySelector(".swiper-button-next")
					},
					a11y: {
						enabled: false
					},
					pagination: {
						el: slider.querySelector('.popup-slider__dots .swiper-pagination'),
						type: 'bullets',
						clickable: true,
						progressbarOpposite: true,
						renderBullet: function renderBullet(index, className) {
							return "<div class=\"" + className + "\">\t\t\t\t\t\t\t<div class=\"swiper-pagination-bullet-progress\"></div>\t\t\t\t\t\t\t</div>";
						}
					},
					on: {
						init: function init() {
							var test = this;
							setTimeout(function () {
								test.autoplay.stop();
							}, 0);
						},
						reachEnd: function reachEnd() {
							slider.querySelector(".popup-slider__arrows .swiper-button-next").addEventListener("click", function () {
								setTimeout(function () {
									sliderContext.firstLevelSwiper.el.swiper.slideNext();
								}, 200);
							}, {
								once: true
							});
						},
						reachBeginning: function reachBeginning() {
							slider.querySelector(".popup-slider__arrows .swiper-button-prev").addEventListener("click", function () {
								setTimeout(function () {
									sliderContext.firstLevelSwiper.el.swiper.slidePrev();
								}, 100);
							}, {
								once: true
							});
						}
					}
				});
				_this3.secondLevelSwipers.push(swiper);
			});
		}
	}, {
		key: "pauseAll",
		value: function pauseAll() {
			this.secondLevelSwipers.forEach(function (item) {
				item.autoplay.stop();
			});
		}
	}, {
		key: "createFirstLevelListeners",
		value: function createFirstLevelListeners() {
			var _this4 = this;

			// Event чтобы перелистывать по клику.
			Object.values(this.firstLevelSwiper.slides).filter(function (item) {
				return typeof item !== "number";
			}).forEach(function (slide, index) {
				slide.addEventListener('click', function (e) {
					// console.log('click')
					_this4.slideByIndex(index);
				});
			});
		}
	}, {
		key: "slideByIndex",
		value: function slideByIndex(index) {
			this.firstLevelSwiper.slideTo(index);
		}
	}, {
		key: "setAutoplay",
		value: function setAutoplay(index) {
			index = +index;
			this.secondLevelSwipers.map(function (item, itemIndex) {
				if (itemIndex === index) {
					item.autoplay.start();
				} else {
					item.autoplay.stop();
				}
			});
		}
	}]);

	return storiesSlider;
}();

